/*
 * @Author: wsx
 * @Date: 2022-01-05 11:37:50
 * @LastEditTime: 2022-01-11 17:17:56
 * @LastEditors: your name
 * @Description:
 */

import util from "@util/js";
import router from "./index";

import { getRouter } from "@/api/common";
const modules = require.context("./modules", true, /\.js$/);

const routeModuleList = {};
modules.keys().forEach(key => {
  const mod = modules(key).default || modules(key);
  mod.forEach(item => {
    routeModuleList[item.name] = item;
  });
});
export const routerGo = async (to, next) => {
  const res = await getRouter();
  const routerList = util.flattenDeep(res.menuList, "list"); // 请求得到的路由数据
  if (!routerList) {
    util.setStorage("router", routerList); // 存储路由到localStorage
  }
  routerList.forEach(item => {
    if (routeModuleList[item.url]) {
      const routeModule = routeModuleList[item.url];
      if (routeModule) {
        if (item.name) {
          routeModule.meta.title = item.name;
        }
        router.addRoute("index", routeModule); // 动态添加路由
      }
    }
  });
  next({ ...to, replace: true });
};
